import { Icon, type TIconProps } from '~/components/icon'
import { useLinkContext } from '../link'
import type { LinkIconProps, LinkScopedProps } from '../link.types'

export function LinkIcon({
  __scopeLink,
  color = 'colorTextNeutralDefault',
  className,
  ...props
}: LinkScopedProps<LinkIconProps> & { className?: string }) {
  const { size, disabled } = useLinkContext('LinkIcon', __scopeLink)

  const iconSizeMapper: Record<string, TIconProps['size']> = {
    md: 'tiny',
    ml: 'tiny',
  } as const

  return (
    <div
      className={`flex items-center ${className && className}`}
      role="figure"
    >
      <Icon
        {...props}
        symbol="rdicon-open"
        color={disabled ? 'colorTextNeutralDisabled' : color}
        size={iconSizeMapper[size!]}
      />
    </div>
  )
}
